export enum ControlType {
	Scrolling                        = 0,
	Touch__And__Keyboard             = 1,
	Touch__And__Keyboard__And__Mouse = 2,
	Touch__And__Gyroscope            = 3,
	VR_Tracking                      = 4,
}


export enum XR_MOVEMENT_TYPE {
	TELEPORT = 0,
	CLIMB	 = 1,
}
